module.exports = __webpack_public_path__ + "img/img_61284_0_1.43fa1219.png";